'use client';

import { useEffect } from 'react';

interface AssistantButtonProps {
  onOpen?: () => void;
  /** Context to pass to the assistant (planId, planData, etc.) */
  context?: Record<string, unknown>;
  /** Specific agent to route to (e.g., 'degree_planning_agent') */
  agentId?: string;
}

export default function AssistantButton({ onOpen, context, agentId }: AssistantButtonProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const pageContext = {
      ...(context ?? {}),
      route: window.location.pathname,
      ...(agentId ? { agentId } : {}),
      ...(onOpen ? { hasCustomAssistantOpenHandler: true } : {}),
    };
    window.__scarletAssistantPageContext = pageContext;
    window.dispatchEvent(new Event('scarlet:page-context'));

    return () => {
      if (window.__scarletAssistantPageContext === pageContext) {
        delete window.__scarletAssistantPageContext;
        window.dispatchEvent(new Event('scarlet:page-context'));
      }
    };
  }, [agentId, context, onOpen]);

  return null;
}
